import { render } from "./register-stage-newsletter.vue?vue&type=template&id=5efa14fe&scoped=true"
import script from "./register-stage-newsletter.vue?vue&type=script&lang=js"
export * from "./register-stage-newsletter.vue?vue&type=script&lang=js"

import "./register-stage-newsletter.vue?vue&type=style&index=0&id=5efa14fe&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efa14fe"]])

export default __exports__